var _sodipodiNamedview, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoccer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 31.75 31.750002",
    id: "svg1696",
    inkscapeVersion: "1.1.1 (3bf5ae0d25, 2021-09-20)",
    sodipodiDocname: "soccer.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1698",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapePageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    "inkscapeDocument-units": "px",
    showgrid: "false",
    inkscapeZoom: 4.3994184,
    inkscapeCx: 23.75314,
    inkscapeCy: 81.94265,
    "inkscapWindow-width": 2560,
    "inkscapeWindow-height": 1377,
    "inkscapeWindow-x": 1912,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "layer1",
    units: "px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1693"
  })), /*#__PURE__*/React.createElement("g", {
    inkscapeLabel: "Ebene 1",
    inkscapeGroupmode: "layer",
    id: "layer1",
    style: {
      display: "inline"
    },
    transform: "translate(-0.03787441,-0.00135587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 11.469662,7.9645379 0.0028,-0.02364 c 0.06385,-0.505178 0.252236,-1.000831 0.519994,-1.441097 -0.108656,-0.01094 -0.221192,-0.0025 -0.332669,0.02928 l -3.5073167,0.994128 c -0.340078,0.09631 -0.591609,0.383469 -0.642056,0.733072 L 6.9339753,12.22362 c -0.07091,0.489656 0.268464,0.944386 0.75812,1.015648 0.0441,0.0064 0.08714,0.0095 0.129822,0.0095 0.437797,0 0.821267,-0.321734 0.885825,-0.767645 l 0.492831,-3.3923111 2.2344937,-0.633236 c 0.0078,-0.164042 0.0187,-0.327731 0.03457,-0.491067",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.579238,13.032544 20.17763,7.7161819 c 0.01517,0.07479 0.02822,0.149578 0.03775,0.22472 l 0.0025,0.02364 c 0.08396,0.845961 0.05221,1.700742 -0.05468,2.5445861 l 3.035653,3.66642 c 0.177094,0.214136 0.432858,0.324555 0.690739,0.324555 0.201083,0 0.403578,-0.06738 0.570794,-0.206022 0.381353,-0.315383 0.43427,-0.88018 0.118886,-1.261533",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.905696,17.283869 -2.9788557,3.90525 c -0.400403,0.524581 -0.299508,1.274234 0.225072,1.674636 0.216253,0.164748 0.470959,0.244828 0.7239,0.244828 0.3594807,0 0.7154337,-0.161925 0.9503837,-0.470253 l 3.7211,-4.877858 c 0.111125,-0.145697 0.182386,-0.308328 0.217664,-0.476603 h -2.859264",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 15.74286,17.283869 12.505418,22.1201 8.5797073,28.090159 c -0.362656,0.551391 -0.209903,1.292225 0.341489,1.65488 0.202141,0.132997 0.430388,0.196497 0.655108,0.196497 0.389114,0 0.7704667,-0.189441 0.9997717,-0.538338 l 3.92042,-5.961945 3.978628,-5.943601 c 0.04621,-0.06844 0.08361,-0.140052 0.113947,-0.213783 H 15.74286",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 24.435305,27.738439 c 0,1.700742 -1.392061,3.07975 -3.110089,3.07975 -1.717322,0 -3.109736,-1.379008 -3.109736,-3.07975 0,-1.700742 1.392414,-3.079397 3.109736,-3.079397 1.718028,0 3.110089,1.378655 3.110089,3.079397",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.978413,15.106172 c 0.885472,-2.277887 1.576917,-4.738512 1.347611,-7.0530871 -0.14358,-1.137003 -1.1049,-2.111022 -1.809044,-2.239433 -0.387351,0.420158 -0.886884,0.728839 -1.466498,0.868539 -0.22225,0.05327 -0.450144,0.08043 -0.677686,0.08043 -0.68192,0 -1.32327,-0.233539 -1.857375,-0.636411 -0.540103,0.399697 -1.052336,1.12148 -1.153936,1.926872 -0.229659,2.3145751 0.461786,4.7752001 1.347964,7.0530871 h 4.268964",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 17.424552,2.8182149 c 0.328083,1.363487 -0.381,2.703337 -1.583973,2.992967 -1.202972,0.289278 -2.444397,-0.581025 -2.772128,-1.944511 -0.328436,-1.363133 0.381,-2.703336 1.583973,-2.99261395 1.202972,-0.289631 2.444044,0.58067195 2.772128,1.94415795",
    style: {
      fill: "#100f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.0352778
    },
    id: "path1106"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccer);
export default __webpack_public_path__ + "static/media/soccer.87a1fcf81938146e229ea2b67620e2e5.svg";
export { ForwardRef as ReactComponent };